import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { removeTags } from '@/utility';
import { buildReferencing, showInCitationPanelGenerator, useCitation } from '@/utils/citationPanelUtils';
import CitationEntryUnavailable from '@/components/citation-entry-unavailable.vue';
import { useRepositories } from '@/plugins/repositories';
export default defineComponent({
  name: 'CitationPanelGuideline',
  components: {
    CitationEntryUnavailable: CitationEntryUnavailable
  },
  props: {
    documentId: {
      type: String,
      required: false,
      default: undefined
    },
    sectionKeys: {
      type: Array,
      required: false,
      default: undefined
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props, context) {
    var router = useRouter();
    var repositories = useRepositories();
    var reference = computed(function () {
      return {
        documentId: props.documentId,
        sectionKeys: props.sectionKeys
      };
    });
    var _useCitation = useCitation(reference, {
        fetcher: function () {
          var _fetcher = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(documentId, sectionKeys) {
            var docSections;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return repositories.citations.getCitationGuideline(documentId, sectionKeys);
                case 1:
                  docSections = _context.v;
                  return _context.a(2, buildReferencing(docSections));
              }
            }, _callee);
          }));
          function fetcher(_x, _x2) {
            return _fetcher.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        }),
        beforeFetch: function beforeFetch() {
          return context.emit('update:loading', true);
        },
        afterFetch: function afterFetch() {
          return context.emit('update:loading', false);
        }
      }),
      guidelines = _useCitation.list;
    var guidelineLink = function guidelineLink(guideline) {
      return "/document/".concat(guideline.docId);
    };
    var showInCitationPanel = showInCitationPanelGenerator(router);
    return {
      guidelines: guidelines,
      guidelineLink: guidelineLink,
      showInCitationPanel: showInCitationPanel,
      removeTags: removeTags
    };
  }
});